// extracted by mini-css-extract-plugin
export default {"invalid-error":"InterestForm_invalid-error__laj1B","submitBtn":"InterestForm_submitBtn__dMM9o"};